import Header from './components/Header';
import Hero from './components/Hero';
import SectionContact from './components/SectionContact';
import SectionIndex from './components/SectionIndex';
import SectionUpdates from './components/SectionUpdates';
import SectionTopics from './components/SectionTopics';
import SectionFAQ from './components/SectionFAQ';
import SectionMedia from './components/SectionMedia';
import SectionAbout from './components/SectionAbout';
import SectionApp from './components/SectionApp';
import SectionFeatures from './components/SectionFeatures';
import SectionRanking from './components/SectionRanking';
import SectionCards from './components/SectionCards';
import SectionComments from './components/SectionComments';
import SectionCarousel from './components/SectionCarousel';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionContact />
        <SectionIndex />
        <SectionUpdates />
        <SectionTopics />
        <SectionFAQ />
        <SectionMedia />
        <SectionAbout />
        <SectionApp />
        <SectionFeatures />
        <SectionRanking />
        <SectionCards />
        <SectionComments />
        <SectionCarousel />
      </main>
      <Footer />
    </>
  );
}